/**
 * Draws an SVG document string to a PNG picture, off screen, for a report (the
 * ligand interaction diagram). Browser only: it needs an Image and a canvas.
 */

/**
 * @param {string} svg - a complete SVG document (with width, height and viewBox)
 * @param {{ width: number, height: number, pixelRatio?: number }} size - in layout
 *   pixels; the picture is `pixelRatio` times larger
 * @returns {Promise<{ dataUrl: string, width: number, height: number }>}
 */
export async function renderSvgToPng(svg, { width, height, pixelRatio = 2 }) {
    if (typeof document === 'undefined' || /jsdom/i.test(window.navigator?.userAgent || '')) {
        throw new Error('Pictures can be drawn only in a browser');
    }
    const image = new Image();
    const loaded = new Promise((resolve, reject) => {
        image.onload = resolve;
        image.onerror = () => reject(new Error('The diagram could not be drawn'));
    });
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
    await loaded;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(width * pixelRatio);
    canvas.height = Math.round(height * pixelRatio);
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    return { dataUrl: canvas.toDataURL('image/png'), width, height };
}
